import { StyleSheet, View } from 'react-native';

import { OutlineButton, PrimaryButton } from '@/components/atoms/button';
import { ONBOARDING_MAX_CONTENT_WIDTH } from '@/components/molecules/onboarding/OnboardingStepContent';
import { spacing } from '@/theme';

interface OnboardingButtonConfig {
  readonly label: string;
  readonly onPress: () => void;
  readonly variant: 'primary' | 'outlined';
  readonly testID?: string;
}

interface OnboardingButtonGroupProps {
  readonly buttons: OnboardingButtonConfig[];
}

export const OnboardingButtonGroup = ({ buttons }: OnboardingButtonGroupProps) => (
  <View style={styles.container} testID="onboarding-button-group">
    {buttons.map((button) => {
      if (button.variant === 'primary') {
        return (
          <PrimaryButton key={button.label} onPress={button.onPress} testID={button.testID}>
            {button.label}
          </PrimaryButton>
        );
      }

      return (
        <OutlineButton key={button.label} onPress={button.onPress} testID={button.testID}>
          {button.label}
        </OutlineButton>
      );
    })}
  </View>
);

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: ONBOARDING_MAX_CONTENT_WIDTH,
    alignSelf: 'center',
    gap: spacing[4],
    marginTop: spacing[7],
    paddingBottom: spacing[3],
    paddingHorizontal: spacing[4],
  },
});
